import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    container: {
        backgroundColor: theme?.assignTable?.backgroundColor,
    },
    header: {
        backgroundColor: theme?.assignTable?.headerBackgroundColor,
    },
    title: {
        fontWeight: 600,
        textAlign: 'center',
        color: theme?.assignTable?.textColor,
        marginLeft: theme.spacing(2),
    },
    closeImg: {
        color: theme?.assignTable?.closeIconColor,
    },
    label: {
        color: theme?.assignTable?.textColor,
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '21px',
    },
    button: {
        backgroundColor: theme?.assignTable?.primaryButtonBackgroundColor,
        color: theme?.assignTable?.primaryButtonTextColor,
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    secondaryButton: {
        backgroundColor: theme?.assignTable?.secondaryButtonBackgroundColor,
        color: theme?.assignTable?.secondaryButtonTextColor,
        borderColor: theme?.assignTable?.secondaryButtonBorderColor,
    },
    guestContainer: {
        backgroundColor: theme?.assignTable?.guestBackground,
        borderRadius: theme.spacing(0.5),
    },
    guestDetails: {
        color: theme?.assignTable.guestHeaderColor,
        marginBottom: '10px',
    },
    guestLabel: {
        color: theme?.assignTable.guestLabelColor,
    },
    guestValue: {
        color: theme?.assignTable.guestValueColor,
        fontSize: '16px',
        fontWeight: 500,
        marginBottom: '10px',
    },
    guestEmail: {
        color: theme?.assignTable.guestValueColor,
        fontSize: '12px',
        fontWeight: 500,
        marginBottom: '10px',
    },
    partySizeBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: theme.spacing(0.5),
        height: '45px',
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        color: theme?.assignTable.partySizeTextColor,
        backgroundColor: theme?.assignTable.partySizeBackgroundColor,
    },
    cardContainer: {
        backgroundColor: theme?.assignTable.tableCardBackground,
        borderRadius: theme.spacing(0.5),
        padding: theme.spacing(1),
    },
    tableCard: {
        backgroundColor: 'transparent',
        height: '60px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: theme.spacing(0.5),
        borderColor: theme?.assignTable.tableBorderColor,
        borderWidth: '1px',
        borderStyle: 'solid',
    },
    tableText: {
        color: theme?.assignTable.tableTextColor,
    },
    selectedTableCard: {
        borderColor: theme?.assignTable.selectedTableCardBackground,
        backgroundColor: theme?.assignTable?.selectedTableCardBackground,
    },
    smsIcon: {
        height: 28,
        width: 28,
        color: theme?.assignTable?.closeIconColor,
    },
}));

export default useStyles;
